import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Repository } from '@clavisco/core';

@Injectable({
  providedIn: 'root'
})
export class AuthorizeGuard implements CanActivate {
  constructor(private router: Router) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    let currentSession: any = Repository.Behavior.GetStorageObject("CurrentSession")!;
    
    if (!currentSession?.access_token) return this.redirectTo();

    const token = currentSession.access_token;

    const payload = this.decodePayload(token);
      

    if (!payload?.exp) return this.redirectTo();

    const now = Math.floor(Date.now() / 1000); // current time in seconds

    if (payload.exp < now) {

      localStorage.removeItem('access_token');
      return this.redirectTo();
    }

      return !!currentSession
  }

  private redirectTo() : Promise<boolean> {
      return this.router.navigateByUrl('/login');
  }

  private decodePayload(token: string): any {
    try {
      const base64Payload = token.split('.')[1];
      const payload = atob(base64Payload);
      return JSON.parse(payload);
    } catch (e) {
      return null;
    }
  }
}
